import s from './loader.module.css';
import Lottie from "react-lottie";
import React from "react";
import LoadBlack from "./LoadBlack.json";

export function Loader() {

    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: LoadBlack,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    };

    return (
        <>
            <div
                style={{
                    height: '20vh',
                    width: '10vw',
                }}
            >
                <Lottie
                    options={defaultOptions}
                    height={120}
                    width={120}
                />
            </div>
        </>
    );
}